
export default function CTAFinale() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#E879F9]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#22C55E]/10 rounded-full blur-3xl"></div>
      
      {/* Pattern Overlay */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl bg-gradient-to-br from-[#E879F9] to-[#22C55E] mb-8 shadow-2xl shadow-[#E879F9]/30">
            <i className="ri-sparkling-line text-4xl text-white"></i>
          </div>

          {/* Title */}
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Trasforma il Tuo Brand in un
            <span className="block mt-2 bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent">
              Asset Strategico di Valore
            </span>
          </h2>

          {/* Description */}
          <p className="text-xl md:text-2xl text-slate-300 max-w-4xl mx-auto mb-12 leading-relaxed">
            Non lasciare che il valore del tuo brand rimanga invisibile. 
            Inizia oggi il percorso di valorizzazione con il metodo BCI certificato.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16">
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/contatti')}
              className="group px-10 py-5 bg-gradient-to-r from-[#E879F9] to-[#22C55E] text-white rounded-full font-bold text-xl shadow-2xl shadow-[#E879F9]/30 hover:shadow-[#E879F9]/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Richiedi Consulenza Gratuita
              <i className="ri-arrow-right-line ml-3 group-hover:translate-x-2 transition-transform duration-300"></i>
            </button>
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/servizi')}
              className="px-10 py-5 bg-white/10 backdrop-blur-sm text-white rounded-full font-bold text-xl border-2 border-white/20 hover:bg-white/20 hover:border-white/40 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Esplora i Servizi
              <i className="ri-service-line ml-3"></i>
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent mb-2">
                500+
              </div>
              <div className="text-slate-300 font-medium">
                Brand Valorizzati
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#22C55E] to-[#E879F9] bg-clip-text text-transparent mb-2">
                €2.5B+
              </div>
              <div className="text-slate-300 font-medium">
                Valore Certificato
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#E879F9] to-[#22C55E] bg-clip-text text-transparent mb-2">
                98%
              </div>
              <div className="text-slate-300 font-medium">
                Clienti Soddisfatti
              </div>
            </div>

            <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
              <div className="text-4xl font-bold bg-gradient-to-r from-[#22C55E] to-[#E879F9] bg-clip-text text-transparent mb-2">
                15+
              </div>
              <div className="text-slate-300 font-medium">
                Anni di Esperienza
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Features */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mt-16">
          <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#E879F9] to-[#22C55E] flex items-center justify-center flex-shrink-0 shadow-lg">
              <i className="ri-shield-check-line text-xl text-white"></i>
            </div>
            <div>
              <h4 className="text-white font-bold text-lg mb-1">Certificazione Ufficiale</h4>
              <p className="text-slate-400 text-sm">Metodo BCI riconosciuto e certificato</p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#22C55E] to-[#E879F9] flex items-center justify-center flex-shrink-0 shadow-lg">
              <i className="ri-time-line text-xl text-white"></i>
            </div>
            <div>
              <h4 className="text-white font-bold text-lg mb-1">Risultati Rapidi</h4>
              <p className="text-slate-400 text-sm">Analisi completa in 4-6 settimane</p>
            </div>
          </div>

          <div className="flex items-start gap-4 bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 hover:border-white/20 transition-all duration-300">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#E879F9] to-[#22C55E] flex items-center justify-center flex-shrink-0 shadow-lg">
              <i className="ri-customer-service-line text-xl text-white"></i>
            </div>
            <div>
              <h4 className="text-white font-bold text-lg mb-1">Supporto Dedicato</h4>
              <p className="text-slate-400 text-sm">Team di esperti sempre disponibile</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
